import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const getMeta = () => axios.get(`${API}/meta`).then((r) => r.data);
export const getAlerts = () => axios.get(`${API}/alerts`).then((r) => r.data);
export const getNowcast = () => axios.get(`${API}/nowcast`).then((r) => r.data);
export const getFlood = () => axios.get(`${API}/geo/flood`).then((r) => r.data);
export const getGpmConfig = () => axios.get(`${API}/geo/gpm-config`).then((r) => r.data);
export const getSaih = () => axios.get(`${API}/ground/saih`).then((r) => r.data);
export const getEms = () => axios.get(`${API}/ground/ems`).then((r) => r.data);
export const postAliaNarrative = (alertId, lang = "es") =>
  axios.post(`${API}/alia/narrative`, { alert_id: alertId, lang }).then((r) => r.data);
export const postAliaAsk = (question, lang = "es", history = [], sessionId = "") =>
  axios
    .post(`${API}/alia/ask`, { question, lang, history, session_id: sessionId }, { timeout: 90000 })
    .then((r) => r.data);
export const getInfra = (layer) =>
  axios.get(`${API}/geo/infrastructure/${layer}`).then((r) => r.data);
export const getRadarStatus = () => axios.get(`${API}/geo/radar/status`).then((r) => r.data);
export const getReports = () => axios.get(`${API}/reports`).then((r) => r.data);
const triggerDownload = (blob, filename) => {
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
};
export const downloadReport = async (reference, lang = "es") => {
  const res = await axios.get(`${API}/reports/${reference}/pdf`, { params: { lang }, responseType: "blob" });
  triggerDownload(res.data, `${reference}.pdf`);
};
export const getDanaState = (checkpoint) =>
  axios.get(`${API}/dana/state`, { params: { checkpoint } }).then((r) => r.data);
export const getDanaGeo = () => axios.get(`${API}/dana/geo`).then((r) => r.data);
export const downloadDanaReport = async (lang = "es") => {
  const res = await axios.get(`${API}/dana/report/pdf`, { params: { lang }, responseType: "blob" });
  triggerDownload(res.data, "RESILIO_DANA_VALIDACION.pdf");
};
